import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'

import MultiplyFactors from './components/MultiplyFactors'
import { difficulty } from './constants'

export default function FiveFactors({ ...props }: ActivityProps): React.ReactElement {
  if (props.difficultyLevel) {
    return (
      <MultiplyFactors
        amount={5}
        maxNumber={difficulty(props.difficultyLevel)[1]}
        minNumber={difficulty(props.difficultyLevel)[0]}
        {...props}
      />
    )
  }

  return <></>
}
